module.exports = __webpack_public_path__ + "img/frame (11).3f66cc45.jpg";